import rtk, { onBoot } from 'rtk';
import screenfull from 'screenfull';

/*
 * constants
 */
import { name } from './constants';
import { error, change } from './actions';

/* ************************ */

const { createReducer } = rtk(name);

const initialState = {
  isFullscreen: false,
};

export const reducer = createReducer(initialState, {
  [change]: (state, { payload }) => {
    state.isFullscreen = payload;
  },
});

onBoot((_, { dispatch, getState }) => {
  screenfull.on('error', (event) => {
    dispatch(error(event));
  });
  screenfull.on('change', (event) => {
    dispatch(change(screenfull.isFullscreen));
  });
});
